import { Injectable } from '@angular/core'
import { User } from 'models'

@Injectable()
export abstract class IAuthorization {
  abstract allowed(...args: any[]): boolean
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/auth/i-authorization.service.ts